import { userPrivacySetting } from '@/Models';
import { consentManager } from './ConsentManager';
import { analyticsPluginName } from '@/Utils/AnalyticsUtility';

/**
 * @param {object} pluginConfig
 * @param {string} pluginConfig.beaconId - HelpScout beacon ID
 */
export default function helpScoutPlugin(pluginConfig) {
    consentManager.register(analyticsPluginName.helpScout, userPrivacySetting.functional, () => {
        window.Beacon = window.Beacon || function(method, options, data) {
            (window.Beacon.readyQueue = window.Beacon.readyQueue || []).push({
                method, options, data,
            });
        };

        function loadBeacon() {
            const script = document.createElement('script');
            script.async = true;
            script.src = 'https://beacon-v2.helpscout.net';
            document.head.appendChild(script);
        }

        if (document.readyState === 'complete') {
            loadBeacon();
        }
        else {
            window.addEventListener('load', loadBeacon);
        }

        window.Beacon('init', { beaconId: pluginConfig.beaconId });
    });

    return {
        name: analyticsPluginName.helpScout,
        config: pluginConfig,
        track: () => {},
    };
}
